
<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style=" border-radius: 5px !important;padding-left:0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-nav>
            <b-button @click="previousDash" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Reports</b-navbar-brand>
        </b-navbar>

        <b-card class="formCard">
          <b-card-text>
            <div class="gutr">
              <b-card no-body class="gutr">
                <b-tabs card>
                  <b-tab disabled></b-tab>
                  <b-tab title="Transportation">
                    <div
                      v-if="$sessionsStorage.get('designation')=='Admin' &&  $sessionsStorage.get('userLevel')=='1'"
                    >
                      <div class="page-header">
                        <div class="input-group">
                          <date-picker
                            v-model="searchModal.dateRangeTPT"
                            range
                            :lang="langTPT"
                            format="YYYY-MM-DD"
                            confirm
                            @change="onConfirmDateRangeTPT"
                          ></date-picker>
                          <a
                            style="margin-left:10px"
                            @click="onDownloadPDF('3')"
                            class="btn btn-warning btn-icon text-white mr-2"
                            id="daterange-btn"
                            data-toggle="tooltip"
                            title
                            data-placement="bottom"
                            data-original-title="Calendar"
                          >
                            <span>
                              <i class="fa fa-file-pdf-o"></i>
                            </span>
                          </a>
                          <a
                            style="margin-left:10px"
                            @click="onDownloadExcel('3')"
                            class="btn btn-warning btn-icon text-white mr-2"
                            id="daterange-btn"
                            data-toggle="tooltip"
                            title
                            data-placement="bottom"
                            data-original-title="Calendar"
                          >
                            <span>
                              <i class="fa fa-file-excel-o"></i>
                            </span>
                          </a>
                        </div>
                      </div>

                      <b-table
                        responsive:true
                        :items="tptSearchData"
                        :fields="fieldsTPT"
                        :per-page="perPageTPT"
                        :sort-by.sync="sortByTPT"
                        :sort-desc.sync="sortDescTPT"
                        :sort-direction="sortDirectionTPT"
                      >
                        <!-- <template slot="top-row" slot-scope="{ fields }">
                            <td v-for="fieldTPT in fields" :key="fieldTPT.key">
                              <input
                                style="width:110px;height:25px;border-radius:5px;font-size: 12px;text-align:center"
                                v-model="filtersTPT[fieldTPT.key]"
                                :placeholder="fieldTPT.label"
                                @input="getAdvanceSearchDataTPT('0','1')"
                              >
                            </td>
                        </template>-->
                        <template slot="clientName" slot-scope="row1">
                          <h6>
                            <b-badge variant="light">{{row1.item.clientName}}</b-badge>
                          </h6>
                          Invoice No :
                          {{row1.item.invoiceSeries}}
                          <br>
                          Invoice Date :
                          {{row1.item.loginTime | moment}}
                        </template>
                       
                        <template slot="multipleContainerType" slot-scope="row5">
                          <span
                            v-for="(item,index3) in row5.item.multipleContainerType.split(',')"
                            :key="index3"
                          >
                            <h6>
                              <b-badge variant="light">{{item}}</b-badge>
                            </h6>
                          </span>
                        </template>
                        <template slot="ContainerNo" slot-scope="row50">
                          <span
                            v-for="(item1,index3) in row50.item.ContainerNo.split(',')"
                            :key="index3"
                          >
                            <h6>
                              <b-badge variant="light">{{item1}}</b-badge>
                            </h6>
                          </span>
                        </template>

                        <template slot="shipLine" slot-scope="row7">
                          <span
                            v-for="(item9,index5) in row7.item.shipLine.split(',')"
                            :key="index5"
                          >
                            <h6>
                              <b-badge variant="light">{{item9}}</b-badge>
                            </h6>
                          </span>
                        </template>
                      </b-table>
                      <div class="pull-right">
                        <b-pagination
                          v-model="currentPageTPT"
                          :per-page="perPageTPT"
                          :total-rows="totalRowsTPT"
                          @change="onPageChangeTPT($event)"
                        ></b-pagination>
                      </div>
                    </div>
                  </b-tab>
                  <b-tab title="Transportation">Tab Contents 2</b-tab>
                  <b-tab title="Transportation">Tab Contents 2</b-tab>
                  <b-tab title="Transportation">Tab Contents 2</b-tab>
                  <b-tab title="Transportation">Tab Contents 2</b-tab>
                </b-tabs>
              </b-card>
            </div>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>
  </div>
</template>


<script>
import { URL_BASE } from "../../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../../helper/filters";
import {
  globalPermissionStatus,
  GlobalGetLocation
} from "../../../helper/collection";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import axios from "axios";
import DatePicker from "vue2-datepicker";
import moment from "moment";
import XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";

export default {
  beforeMount() {
    this.$store.dispatch("setCurrentRoute", "/dashboard");
    if (
      this.$sessionsStorage.get("loginId") != undefined &&
      this.$sessionsStorage.get("loginId") != "" &&
      this.$sessionsStorage.get("departmentName") != undefined &&
      this.$sessionsStorage.get("departmentName") != "" &&
      this.$sessionsStorage.get("designation") != undefined &&
      this.$sessionsStorage.get("designation") != ""
    ) {
      this.getAdvanceSearchDataTPT("0", "1", "1");
    } else {
      this.$sessionsStorage.set("loginId", "");
      this.$router.push({
        path: "/Login/"
      });
    }
  },
  mounted() {},

  beforeDestroy() {},
  destroyed() {},
  filters: {
    moment(date) {
      return DateFormat(date)
    }
  },
  components: {
    // Loading,
    CustomLoader,
    DatePicker
  },
  computed: {
    filteredTPT() {
      const filtered = this.tptSearchData.filter(item => {
        return Object.keys(this.filtersTPT).every(key =>
          String(item[key])
            .toLowerCase()
            .includes(this.filtersTPT[key].toLowerCase())
        );
      });

      return filtered.length > 0
        ? filtered
        : [
            // {
            //   clientName: "",
            //   type: "",
            //   fromLocation: "",
            //   toLocation: "",
            //   multipleContainerType: "",
            //   shipLine: ""
            // }
          ];
    }
  },
  data() {
    return {
      isLoading: false,
      searchModal: {
        dateRangeTPT: ""
      },
      langTPT: {
        pickers: ["", "", "previous 7 days", "previous 30 days"]
      },
      perPageTPT: 5,
      sortDescTPT: false,
      sortByTPT: null,
      sortDirectionTPT: "asc",
      totalRowsTPT: 0,
      currentPageTPT: 1,
      tptSearchData: [],
      filtersTPT: {
        clientName: "",
        type: "",
        fromLocation: "",
        toLocation: "",
        multipleContainerType: "",
        ContainerNo: "",
        shipLine: ""
      },
      columnsTPTpdf: [
        "AssignmentNo",
        "Client",
        "Export_Import",
        "Handover",
        //  "InvoiceDate",
        //  "InvoiceNo",
        "Pickup",

        "ContainerNo",
        "ContainerType",
        "shipLine"
      ],
      fieldsTPT: [
        {
          key: "clientName",
          mainkey: "clientName",
          label: " Client",
          sortable: true,
          sortDirection: "ASC",
          table: "C."
          // thStyle: {
          //   display: "none"
          // }
        },
        {
          key: "type",
          mainkey: "type",
          label: " Export / Import",
          sortable: true,
          sortDirection: "ASC",
          table: "C."
          // thStyle: {
          //   display: "none"
          // }
        },
        {
          key: "fromLocation",
          mainkey: "fromLocation",
          label: " Pickup",
          sortable: true,
          sortDirection: "ASC",
          table: "C."
          // thStyle: {
          //   display: "none"
          // }
        },
        {
          key: "toLocation",
          mainkey: "toLocation",
          label: " Handover",
          table: "C.",
          sortable: true,
          sortDirection: "ASC"
          // thStyle: {
          //   display: "none"
          // }
        },
        {
          key: "multipleContainerType",
          mainkey: "multipleContainerType",
          label: " Container Type",
          table: "C.",
          sortable: true,
          sortDirection: "ASC"
          // thStyle: {
          //   display: "none"
          // }
        },
        {
          key: "ContainerNo",
          mainkey: "ContainerNo",
          label: " Container No. ",
          sortable: true,
          sortDirection: "ASC",
          table: "D."
          // thStyle: {
          //   display: "none"
          // }
        },
        {
          key: "shipLine",
          mainkey: "shipLine",
          label: " Shipping Line",
          sortable: true,
          sortDirection: "ASC",
          table: "E."
          // thStyle: {
          //   display: "none"
          // }
        }
      ]
    };
  },
  methods: {
    previousDash() {
      window.history.go(-1);
    },
    onDownloadExcel(id) {
      this.isLoading = true;
      let type_Size = {
        excelData: "abc",
        excelId: id, //for CC =1,FF=2,TPT=3

        ffFromDateRngTPT: this.searchModal.dateRangeTPT[0],
        ffToDateRngTPT: this.searchModal.dateRangeTPT[1],
        searchValTPT: this.filtersTPT,
        fieldsTPT: this.fieldsTPT
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_EmpDashboard/exportToExcel.php`,
        data: JSON.stringify(type_Size),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };
      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            if (id == "1") {
              if (data.CCExcelData.length > 0) {
                var ccExcelReport = XLSX.utils.json_to_sheet(data.CCExcelData);
                var wb = XLSX.utils.book_new();
                wb.Title = "Insert Title Here";
                XLSX.utils.book_append_sheet(wb, ccExcelReport, "SheetOne"); // sheetAName is name of Worksheet
                // XLSX.utils.book_append_sheet(wb, pokemonWS, "pokemons");
                XLSX.writeFile(
                  wb,
                  "CUSTOM_REPORT_" + new Date().toDateString() + ".xlsx"
                );
              } else {
                //this.showMessageSnackbar("No data available");
              }
            }
            if (id == "2") {
              if (data.FFExcelData.length > 0) {
                var ffExcelReport = XLSX.utils.json_to_sheet(data.FFExcelData);
                var wb = XLSX.utils.book_new();
                wb.Title = "Insert Title Here";
                XLSX.utils.book_append_sheet(wb, ffExcelReport, "SheetOne"); // sheetAName is name of Worksheet
                // XLSX.utils.book_append_sheet(wb, pokemonWS, "pokemons");
                XLSX.writeFile(
                  wb,
                  "FREIGHT_REPORT_" + new Date().toDateString() + ".xlsx"
                );
              } else {
                //this.showMessageSnackbar("No data available");
              }
            }
            if (id == "3") {
              if (data.TPTReportData.length > 0) {
                var tptExcelReport = XLSX.utils.json_to_sheet(
                  data.TPTReportData
                );
                var wb = XLSX.utils.book_new();
                wb.Title = "Insert Title Here";
                XLSX.utils.book_append_sheet(wb, tptExcelReport, "SheetOne"); // sheetAName is name of Worksheet
                // XLSX.utils.book_append_sheet(wb, pokemonWS, "pokemons");
                XLSX.writeFile(
                  wb,
                  "Transport_REPORT_" + new Date().toDateString() + ".xlsx"
                );
              } else {
                //this.showMessageSnackbar("No data available");
              }
            }
            this.isLoading = false;
          }
        })
        .catch(error => {});
    },
    onDownloadPDF(id) {
      this.isLoading = true;
      let type_Size = {
        excelData: "abc",
        excelId: id, //for CC =1,FF=2,TPT=3
        ffFromDateRngTPT: this.searchModal.dateRangeTPT[0],
        ffToDateRngTPT: this.searchModal.dateRangeTPT[1],
        searchValTPT: this.filtersTPT,
        fieldsTPT: this.fieldsTPT
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_EmpDashboard/exportToExcel.php`,
        data: JSON.stringify(type_Size),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };
      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            if (id == "1") {
            }
            if (id == "2") {
            }
            if (id == "3") {
              if (data.TPTReportData.length > 0) {
                let mainArray = [];

                data.TPTReportData.map(x => {
                  let tempArray = [];
                  this.columnsTPTpdf.map(y => {
                    if (x.hasOwnProperty(y)) {
                      tempArray.push(x[y]);
                    }
                  });
                  mainArray.push(tempArray);
                });

                //var imgData = BASE64IMAGE;

                var doc = new jsPDF("l", "px", [1000, 600]);
                // doc.addImage(imgData, "JPEG", 340, 0, 60, 40);
                doc.text(
                  250,
                  53,
                  "PRIDEL TRANSPORTATION REPORT  "
                  // +
                  //   this.FromDate +
                  //   " TO " +
                  //   this.ToDate
                );
                // doc.text(230, 53, "GOGO CINEMA SHOW DATE REPORT FOR ");
                doc.setFontSize(17);

                doc.autoTable({
                  head: [this.columnsTPTpdf],
                  theme: "grid", // 'striped'|'grid'|'plain'
                  body: mainArray,
                  margin: { top: 60 },
                  headStyles: {
                    // fillColor: [209, 46, 30, 1]
                    // fillColor: [195, 66, 0]
                    fillColor: [210, 29, 29]
                  }
                });
                doc.save(
                  "TRANSPORTATION_REPORT" + new Date().toDateString() + ".pdf"
                );
              } else {
                //this.showMessageSnackbar("No data available");
              }
            }
            this.isLoading = false;
          }
        })
        .catch(error => {});
    },
    onPageChangeTPT: function(eventTPT) {
      let CURRENTTPT = 0;
      if (eventTPT == "1") {
        CURRENTTPT = 0;
      } else {
        CURRENTTPT = eventTPT * this.perPageTPT - this.perPageTPT;
      }
      this.getAdvanceSearchDataTPT(CURRENTTPT, "2", eventTPT);
    },
    getAdvanceSearchDataTPT(CURRENTTPT, SEARCHTPT, pageNumberTPT) {
      this.isLoading = true;

      this.tptSearchData = [];

      let payLoad = {
        advanceSearch: "TPT",
        searchValTPT: this.filtersTPT,
        fieldsTPT: this.fieldsTPT,
        fromSearchTPT: SEARCHTPT,
        currentPageTPT: CURRENTTPT,
        perPageTPT: this.perPageTPT,
        ffFromDateRngTPT: this.searchModal.dateRangeTPT[0],
        ffToDateRngTPT: this.searchModal.dateRangeTPT[1]
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_EmpDashboard/dashboardAdvanceSearch.php`,
        data: JSON.stringify(payLoad),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };
      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            if (SEARCHTPT != "2") {
              this.currentPageTPT = 1;
              this.totalRowsTPT = data.totalDataTPT;
            } else {
              this.currentPageTPT = pageNumberTPT;
            }
            if (data.tptSearchData.length > 0) {
              this.tptSearchData = data.tptSearchData;
            }
            this.isLoading = false;
          }
        })
        .catch(error => {});
    },
    onConfirmDateRangeTPT() {
      this.getAdvanceSearchDataTPT("0", "1", "1");
    }
  }
};
</script>

<style scoped>
</style>


	




// WEBPACK FOOTER //
// dashboardTptReports.vue?0457631c